import { Alert } from "@puregym/ui";
import styled from "styled-components";
import labels from "../../labels";

const AlertStyled = styled(Alert)`
  margin-block-start:${({ theme }) => theme.spacing.baseSpacing}};
`;

const SearchResultsAlert = () => (
  <AlertStyled>{labels.errors.noGyms}</AlertStyled>
);

export default SearchResultsAlert;
